import React, { useState } from 'react'
import Style from './DeliveryTabs.module.css'
import DeliveryCurrentRequest from '../DeliveryCurrentRequest/DeliveryCurrentRequest'
import DeliveryFinishedRequest from '../DeliveryFinishedRequest/DeliveryFinishedRequest'
const DeliveryTabs = () => {
    const [checkedClass,setCheckdClass]=useState(false)
    const ClassHandler =()=>{
        setCheckdClass(false)
    }
    const ClassHandler2 =()=>{
        setCheckdClass(true)
    }
    let Content=null
    if(checkedClass) 
    {
        Content=<DeliveryFinishedRequest/>
    }
    if(!checkedClass)
    {
        Content=<DeliveryCurrentRequest/>
    }
    return (
        <div className={Style.PageHolder}>
            <header className={Style.TabsTitle}>
                <div className={checkedClass?Style.normal:Style.checked} onClick={ClassHandler}>درخواست های فعلی</div>
                <div className={checkedClass?Style.checked:Style.normal} onClick={ClassHandler2}>درخواست های قبلی</div>
            </header>
            {Content}
        </div>
    )
}

export default DeliveryTabs
